import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import {Button, Card, Badge, Pagination, Nav, Alert, Tab, Modal} from "react-bootstrap"
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {IconButton} from "@material-ui/core";
import clsx from "clsx";
import ProgressionButtons from "../../SubCompounents/ProgressionButtons";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import PerfectScrollbar from "react-perfect-scrollbar";



import {
    Add,
    AddCommentOutlined,
    Check, CheckOutlined,
    Close, EditOutlined, Equalizer,
    FavoriteBorderOutlined,
    FlagOutlined,
    NotInterestedOutlined,
    TimerOutlined
} from "@material-ui/icons";
import './Exams.css'
import '../../css/siamois.css'
import {useMediaQuery} from "@material-ui/core";
// import Ext from "../../layouts/Ext";

import PieChart from "../../SubCompounents/PieChart";
import {RecaputalitifExamen} from "./Recapitulatifs";
import Select from "react-select";
import {Form} from 'react-bootstrap'
import {Dialog , DialogTitle , DialogContentText , DialogActions , DialogContent} from "@material-ui/core";
import Slide from '@material-ui/core/Slide';
import CreatableSelect from 'react-select/creatable';
import avatar from "../../images/Siamois/images/Me.jpg";
import {useMemo} from "react";
import {useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {deactivateLoading, togglePauseModal} from "../../redux/actions/actions";
import {DoubleArrow} from "@mui/icons-material";
import {PropositionsLoader, QuestionNameLoader, QuestionTextLoader, QuestionTypeLoader} from "./SkeletonLoaders/Loaders";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


function Examen(){
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    const ps = new PerfectScrollbar('#ccqcmNavTabs');
    const pauseModal=useSelector(state=>state.pauseModal);
    const examen=useSelector(state=>state.examen);
    const dispatch= useDispatch();


    const [addToPlayListModalOpen , setAddToPlaylistModalStatus] = useState(false);
    const [reportProblemModalOpen, setReportProblemModalOpenStatus] = React.useState(false);
    const [addCommentDropDownStatus , setAddCommentDropDownStatus] = React.useState(false);
    const [userComment , setUserComment]=React.useState(null);
    const [playListOptions , setPlayListOptions] = useState(
        [
            { value: "playlist 1", label: "playlist 1" },
            { value: "playlist 2", label: "playlist 2" },
            { value: "playlist 3", label: "playlist 3" },
        ]
    );

    useEffect(()=>{
        setTimeout(()=>{
            dispatch(deactivateLoading());
        },10000)
    }, [])
    const toggleAddCommentDropDownStatus= React.useCallback(()=>{
        setAddCommentDropDownStatus(!addCommentDropDownStatus);
        // if(lg) {
        //     setTimeout(()=>{
        //         var myDiv = document.getElementById("cardScrollPart");
        //         myDiv.scrollTop = myDiv.scrollHeight;
        //     },1);
        // }



    }, [addCommentDropDownStatus])
    // useEffect(()=>{
    //     // console.log($('.button'));
    //     $('body').select2({
    //         dropdownParent: $('#myModal')
    //     });
    // },[])

    const handleChangePlayList = (newValue, actionMeta) => {
        // console.group('Value Changed');
        console.log('TAB INDEX =',document.querySelector('#myModal').getAttributeNames());
        console.log(newValue);
        console.log(`action: ${actionMeta.action}`);
        // console.groupEnd();
    };
    const handleInputChangePlayList = (inputValue , actionMeta) => {
        console.log('TAB INDEX =',document.querySelector('#myModal').getAttribute('tabindex'));
        // console.group('Input Changed');
        console.log(inputValue);
        console.log(`action: ${actionMeta.action}`);
        // console.groupEnd();
    };
    const Modals =()=>{
        const AddToPlaylistModal =()=>{
            return null
        }

        const ReportProblemModal=()=>{
            return null;

        }
        return (
            <React.Fragment>
                <AddToPlaylistModal/>
                <ReportProblemModal/>
            </React.Fragment>
        )
    }
    const ExamBadge =(props)=>{
        return(
            <span className="p-3 mr-3 rounded-circle bg-white font-weight-bold d-flex justify-content-center align-items-center" style={ lg ?{color : 'var(--info)', height : '50px' , width : '50px'} : {color : 'var(--info)', height : '40px' , width : '40px'} }>
                                 <span>{props.children}</span>
            </span>
        )
    };
    const QuestionHeader=()=>{
        return (
            <div className="d-none d-lg-flex align-items-center">
                <ExamBadge> QCU </ExamBadge>
                <div id="questionInfo">ECH normal et pathologique - Q 1/22</div>
            </div>
        )
    }
    const ExamCard=React.memo(()=>{


        return (
            <div style={!lg ? {minHeight : '70vh' , display : 'flex', flexDirection : 'column'} : {}} className="card">
                <div className="d-lg-flex w-100">
                    <div className="card-header bg-info flex-column flex-lg-row p-0 p-lg-2" style={lg ?{borderTopRightRadius : 0 , width : '85%'  } : {}}>
                        <div className="d-none d-lg-flex align-items-center">
                            {  examen.loading ? <QuestionTypeLoader/> : <ExamBadge > <span id="ccqcmBadge"> CCQCM</span> </ExamBadge>   }
                            { examen.loading ? <QuestionNameLoader/> : <div id="questionInfo">ECH normal et pathologique - Q 1/22</div>}
                        </div>
                        <div className="d-lg-flex w-md-sm-100">
                            <div id="questionIconsContainer" className="d-flex align-items-center">
                                <div className="d-lg-none"> {  examen.loading ? <QuestionTypeLoader/> : <ExamBadge > <span id="ccqcmBadge">CCQCM</span> </ExamBadge>}</div>
                                <IconButton style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="send a report">
                                    <DoubleArrow onClick={()=>setReportProblemModalOpenStatus(true)}  style={{  fontSize : lg ? 25 : 18 }}  />
                                </IconButton>
                                <IconButton style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="edit">
                                    <EditOutlinedIcon style={{  fontSize : lg ? 25 : 18 }}  />
                                </IconButton>
                                <IconButton onClick={()=>setAddToPlaylistModalStatus(true)} style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="favourite">
                                    <FavoriteBorderOutlined style={{  fontSize : lg ? 25 : 18 }}  />
                                </IconButton>
                                <IconButton style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="send a report">
                                    <FlagOutlined onClick={()=>setReportProblemModalOpenStatus(true)}  style={{  fontSize : lg ? 25 : 18 }}  />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                    <div id="timerContainer" className="white d-lg-flex align-items-lg-center justify-content-lg-center" style={lg ? {width : '15%' , borderTopRightRadius : 'calc(0.75rem - 1px)' , marginBottom: '1px'} : {}}>
                        <Timer/>
                    </div>
                </div>

                <div id="cardScrollPart" style={ lg ? {maxHeight : '60vh' , overflowY : 'auto' } : {maxHeight : '65vh' , overflowY : 'auto'} } className="card-body p-0">
                    {examen.loading ? <QuestionTextLoader/> :
                        <React.Fragment>
                            <div id="questionBody" className="pl-lg-5 pt-lg-3 pr-lg-5  pl-4 pr-4 pt-2 pb-2 "  >
                                L'hyperthopie auriculaire gauche se traduit à la radiographie thoracique ou à l'e.c.g par tous les signes suivants sauf un , lequel?
                            </div>
                            <div className="pl-lg-5 pl-4 mb-lg-3 mb-2"> <Badge style={{color : '#fff'}} variant="success">Siamois</Badge></div>
                        </React.Fragment>

                    }
                    <div className="mr-lg-4 ml-lg-4" style={ lg ?{borderTop : '1px solid #eee'} : {borderTop : '1px solid #eee' , display : 'flex' , flexDirection : 'column'}}>
                            {examen.loading ? <PropositionsLoader/> :<Propositions/>}
                    </div>

                </div>
            </div>
        )
    });

    const Timer=()=>{
        const sm = useMediaQuery('(min-width:576px)');
        const md = useMediaQuery('(min-width:768px)');
        const lg = useMediaQuery('(min-width:992px)');
        const xl= useMediaQuery('(min-width:1200px)');
        return(
            <div className="font-weight-bold" style={ lg ? {color : '#fff' , fontSize : '1.2rem' , padding: '1.5rem 1.875rem'}: {color : '#fff' , fontSize: '0.8rem'}}>
                02:00:00
            </div>
        )
    }
    const DeleteAnswerButton=()=>{
        const sm = useMediaQuery('(min-width:576px)');
        const md = useMediaQuery('(min-width:768px)');
        const lg = useMediaQuery('(min-width:992px)');
        const xl= useMediaQuery('(min-width:1200px)');
        return(
            <Button style={ lg ? {fontSize : '1rem'} : {fontSize : '0.7rem'}}  variant="outline-warning">Effacer la reponse</Button>
        )
    }


    const Proposition =({choosed })=>{
        return(
            <tr>
                <td className={ clsx("pt-lg-3 pb-lg-3 mt-lg-2 pb-1 pt-1 propositionTD d-flex align-items-center mr-3 ml-3 mt-2 mb-2 mr-lg-0 ml-lg-0" , { choosedProp : choosed}) }>
                    {/*<Nav>{pag("sm", true, "info", false, false)}</Nav>*/}
                    {/*size , gutter , variant , bg , circle*/}
                    <Pagination
                        size="sm"
                        className={`mt-4 pagination-gutter pagination-info pagination-circle no-bg`}
                    >
                        <Pagination.Item className={clsx( { choosedPropLetter : choosed })}  active={false}>
                            A
                        </Pagination.Item>
                    </Pagination>
                    <div className={ clsx("propositionText w-100")} >
                        Double contour au niveau de l'arc inférieur droit sur le cliché thoracique pris de face
                    </div>
                </td>
            </tr>
        )
    }
    const Propositions=()=>{
        return(
            <div id="propositionsContainer" className="table-responsive">
                <table id="propositions" className="table shadow-hover">
                    <tbody>
                    <Proposition/>
                    <Proposition choosed={true} />
                    <Proposition />
                    <Proposition/>
                    </tbody>
                </table>
            </div>

        )
    }

    const AddCommentDropDown=({isOpen})=>{
        return null;

    }




    const RecapCard=(props)=>{

        return (
            <div className="widget-stat card bg-dummy" style={ { backgroundColor  : props.juste ? 'var(--success)' : props.fausse ? 'var(--danger)' : props.sansReponse ? 'var(--warning)' : 'var(--info)'  } }>
                <div className="card-body  p-4">
                    <div className="media d-lg-block">
                        <span className="mr-3">
                            {props.children}
                        </span>
                        <div className="media-body text-white text-right">
                            <p className="mb-1">{props.text}</p>
                            <h3 className="text-white">76</h3>
                        </div>
                    </div>
                </div>
            </div>


        )
    };

    return (
        <div className={clsx(pauseModal.isOpen && 'blurred')} style={ lg ?{paddingTop : '7.2rem'} : {paddingTop : '4rem' , minHeight : '100vh'}}>
            <div className="d-lg-flex mt-lg-4 mt-2">
                <div className="col-lg-8" >
                    <ExamCard/>
                    <div className="d-flex justify-content-end mb-3 mb-lg-1">
                        <Button className="light" style={ lg ? {fontSize : '1.2rem'} : {fontSize : '0.9rem'}} variant="primary">Suivant</Button>
                    </div>
                </div>
                {
                    lg ? (
                        <div className="col-lg-4">
                            <RecaputalitifExamen/>
                        </div>
                    ) :null
                }

            </div>
            {/*<Modals/>*/}
            {/*ADD PLAYLIST MODAL*/}
            <Modal
                className="fade bd-example-modal-sm"
                size="sm"
                show={addToPlayListModalOpen}
                id='myModal'
            >
                <Modal.Header>
                    <Modal.Title>Ajouter à une playlist</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() => setAddToPlaylistModalStatus(false)}
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Body className="pt-0 pb-0">
                    <div style={{ borderBottom : '1px solid #EEEEEE' }} className="d-flex justify-content-around   flex-lg-row flex-wrap pt-2 pb-2 ">
                        <Badge className="m-1" variant="dark light">Playlist 1</Badge>
                        <Badge className="m-1" variant="dark light">Playlist 1</Badge>
                        <Badge className="m-1" variant="dark light">Playlist 1</Badge>
                        <Badge className="m-1" variant="dark light">Playlist 1</Badge>
                        <Badge className="m-1" variant="dark light">Playlist 1</Badge>
                        <Badge className="m-1" variant="dark light">Playlist 1</Badge>
                    </div>
                    <div id="SelectPlaylist" className="d-flex flex-column p-2 pb-3 ">
                        <div className="p-2">Nom de playlist : </div>
                        <Select
                            id='mySelect2'
                            isClearable
                            onChange={handleChangePlayList}
                            onInputChange={handleInputChangePlayList}
                            options={playListOptions}
                            style={{
                                lineHeight: "40px",
                                color: "#7e7e7e",
                                paddingLeft: " 15px",
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/*<Button*/}
                    {/*    variant="danger light"*/}
                    {/*    onClick={() => setAddToPlaylistModalStatus(false)}*/}
                    {/*>*/}
                    {/*    Close*/}
                    {/*</Button>*/}
                    <Button variant="primary">Confirmer</Button>
                </Modal.Footer>
            </Modal>

            {/*REPORT PROBLEM MODAL*/}

            <Modal
                className="fade"
                show={reportProblemModalOpen}
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title>Signaler cette question</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() => setReportProblemModalOpenStatus(false)}
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>Veuillez séléctionner la raison la plus appropriée</Form.Label>
                        <Form.Control as="select">
                            <option></option>
                            <option value="1">La question est incorrecte sur le paln des faits</option>
                            <option value="2">La réponse de cette question est erronée</option>
                            <option value="3">L'explication de cette question est inconvenable</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Veuillez écrire des bréves remarques sur cette question</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline">Fermer</Button>
                    <Button variant="primary">Confirmer</Button>
                </Modal.Footer>
            </Modal>

            {/*<AddCommentDropDown isOpen={addCommentDropDownStatus}/>*/}
            {/*Add Comment Modal*/}
            <Modal
                className="fade"
                show={addCommentDropDownStatus}
            >
                <Modal.Body>
                    <PerfectScrollbar
                        id="DZ_W_Notification1"
                        className={` widget-media dz-scroll p-3 height380 ps ps--active-y`}
                    >
                        <ul className="timeline">
                            <li>
                                <div className="mb-1 d-flex justify-content-end mr-1">
                                    <IconButton className="p-0" onClick={()=>setAddCommentDropDownStatus(false)} aria-label="closeDropDownComment">
                                        <Close fontSize="small" style={{color : 'black' }}/>
                                    </IconButton>
                                </div>
                                <div className="timeline-panel align-items-center">
                                    <div className="media mr-2">
                                        <img
                                            alt="image"
                                            width={50}
                                            src={avatar}
                                        />
                                    </div>
                                    <div className="media-body">
                                        {
                                            !userComment ? (
                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                    <Form.Control
                                                        onFocus={()=>{console.log('FOCUS ')}}
                                                        as="textarea" rows={3}
                                                        placeholder="Ecrire votre commentaire ici"
                                                    />
                                                </Form.Group>
                                            ): (
                                                <React.Fragment>
                                                    <h6 className="mb-1" style={{fontSize : '0.7rem'}}>
                                                        Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment
                                                    </h6>
                                                    <small className="d-block">
                                                        29 July 2020 - 02:26 PM
                                                    </small>
                                                </React.Fragment>
                                            )

                                        }

                                    </div>
                                    <div style={{alignSelf : 'center'}}>
                                        {
                                            userComment ? (
                                                <IconButton onClick={()=>setAddCommentDropDownStatus(!addCommentDropDownStatus)} aria-label="addComment">
                                                    <EditOutlined fontSize="small" style={{color : 'black' }}/>
                                                </IconButton>
                                            ): (
                                                <IconButton onClick={()=>setUserComment('bla bla')} aria-label="addComment">
                                                    <CheckOutlined fontSize="small" style={{color : 'green' }}/>
                                                </IconButton>
                                            )
                                        }

                                    </div>
                                </div>
                            </li>
                        </ul>
                    </PerfectScrollbar>
                </Modal.Body>
            </Modal>
            {/*<div*/}
            {/*    className={ clsx('dropdown-menu dropdown-menu-right addCommentDropdown', {show : addCommentDropDownStatus} ) }*/}
            {/*    style={lg ? { width : '20rem' ,position : 'absolute' , top : '6rem' , right : '1rem' , height : 'fit-content'} : md ? {position : 'absolute' , top : '6rem' , right : '1rem' , height : 'fit-content'} : {position : 'absolute' , top : '5rem' , right : '1rem', height : 'fit-content'} }*/}

            {/*>*/}
            {/*    <PerfectScrollbar*/}
            {/*        id="DZ_W_Notification1"*/}
            {/*        className={` widget-media dz-scroll p-3 height380 ps ps--active-y`}*/}
            {/*    >*/}
            {/*        <ul className="timeline">*/}
            {/*            <li>*/}
            {/*                <div className="mb-1 d-flex justify-content-end mr-1">*/}
            {/*                    <IconButton className="p-0" onClick={()=>setAddCommentDropDownStatus(false)} aria-label="closeDropDownComment">*/}
            {/*                        <Close fontSize="small" style={{color : 'black' }}/>*/}
            {/*                    </IconButton>*/}
            {/*                </div>*/}
            {/*                <div className="timeline-panel align-items-center">*/}
            {/*                    <div className="media mr-2">*/}
            {/*                        <img*/}
            {/*                            alt="image"*/}
            {/*                            width={50}*/}
            {/*                            src={avatar}*/}
            {/*                        />*/}
            {/*                    </div>*/}
            {/*                    <div className="media-body">*/}
            {/*                        {*/}
            {/*                            !userComment ? (*/}
            {/*                                <Form.Group controlId="exampleForm.ControlTextarea1">*/}
            {/*                                    <Form.Control*/}
            {/*                                        onFocus={()=>{console.log('FOCUS ')}}*/}
            {/*                                        as="textarea" rows={3}*/}
            {/*                                        placeholder="Ecrire votre commentaire ici"*/}
            {/*                                    />*/}
            {/*                                </Form.Group>*/}
            {/*                            ): (*/}
            {/*                                <React.Fragment>*/}
            {/*                                    <h6 className="mb-1" style={{fontSize : '0.7rem'}}>*/}
            {/*                                        Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment Comment*/}
            {/*                                    </h6>*/}
            {/*                                    <small className="d-block">*/}
            {/*                                        29 July 2020 - 02:26 PM*/}
            {/*                                    </small>*/}
            {/*                                </React.Fragment>*/}
            {/*                            )*/}

            {/*                        }*/}

            {/*                    </div>*/}
            {/*                    <div style={{alignSelf : 'center'}}>*/}
            {/*                        {*/}
            {/*                            userComment ? (*/}
            {/*                                <IconButton onClick={()=>setAddCommentDropDownStatus(!addCommentDropDownStatus)} aria-label="addComment">*/}
            {/*                                    <EditOutlined fontSize="small" style={{color : 'black' }}/>*/}
            {/*                                </IconButton>*/}
            {/*                            ): (*/}
            {/*                                <IconButton onClick={()=>setUserComment('bla bla')} aria-label="addComment">*/}
            {/*                                    <CheckOutlined fontSize="small" style={{color : 'green' }}/>*/}
            {/*                                </IconButton>*/}
            {/*                            )*/}
            {/*                        }*/}

            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </li>*/}
            {/*        </ul>*/}
            {/*    </PerfectScrollbar>*/}
            {/*</div>*/}


            {/*PAUSE MODAL*/}

            <Modal
                className="fade bd-example-modal-sm"
                show={pauseModal.isOpen}
                id='myModal'
                style={{height : '70vh' , overflowY : 'scroll'}}

            >
                <Modal.Header>
                    <Modal.Title>PAUSE</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() =>dispatch(togglePauseModal()) }
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Footer className="d-flex justify-content-around">
                    <Button
                        variant="danger light"
                        className="pauseButtonsModal"
                    >
                        Enregistrer & quitter
                    </Button>
                    <Button
                        className="pauseButtonsModal"
                        variant="primary"
                        onClick={()=>dispatch(togglePauseModal())}
                    >Reprendre</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Examen;
